import PropTypes from "prop-types";

const ServicePayment = ({ className = "" }) => {
  return (
    <section
      className={`self-stretch flex flex-row items-start justify-start pt-0 px-10 pb-[51px] box-border max-w-full text-left text-5xl text-dark-text font-text-regular-lowercase ${className}`}
    >
      <div className="flex-1 flex flex-col items-start justify-start gap-10 max-w-full mq400:gap-5">
        <div className="relative font-semibold">Thanh toán dịch vụ</div>

        <div className="self-stretch flex flex-row items-start justify-start py-0 pl-0.5 pr-0 box-border max-w-full text-lg">
          <div className="flex-1 flex flex-row items-start justify-start flex-wrap content-start gap-[37px] max-w-full mq360:gap-[18px]">
            <div className="flex flex-col items-start justify-start pt-1.5 px-0 pb-0">
              <div className="flex flex-col items-start justify-start gap-[54px]">
                <div className="w-3 h-3 relative rounded-full bg-light-pink z-[1]" />
                <div className="w-3 h-3 relative rounded-full bg-light-pink z-[1]" />
                <div className="w-3 h-14 relative">
                  <div className="absolute top-0 left-0 rounded-full bg-light-pink w-3 h-3 z-[1]" />
                  <div className="absolute bottom-0 left-0 rounded-full bg-light-pink w-3 h-3 z-[1]" />
                </div>
              </div>
            </div>

            <div className="flex-1 flex flex-col gap-4 min-w-[201px] max-w-full">
              <div className="leading-[120%]">
                <p className="m-0">Máy chưa thanh toán sẽ cần thanh toán trễ nhất là 3 ngày.</p>
                <p className="m-0">&nbsp;</p>
                <p className="m-0">Muốn thanh toán, chọn vào bar thông báo chưa thanh toán dịch vụ.</p>
                <p className="m-0">&nbsp;</p>
                <p className="m-0">Thêm thẻ ngân hàng.</p>
                <p className="m-0">&nbsp;</p>
                <p className="m-0">
                  <span>Bấm </span>
                  <span className="font-semibold text-transparent bg-gradient-to-r from-pink-400 to-orange-300 bg-clip-text">
                    Thanh toán Ngay
                  </span>
                  <span> để tiến hành thanh toán.</span>
                </p>
              </div>

              {/* Nút Thanh Toán riêng, chỉ là hiển thị, không có navigate */}
              <div className="mt-4 w-fit bg-gradient-to-r from-pink-400 to-orange-300 text-white font-semibold rounded-full px-6 py-3 cursor-default select-none">
                Thanh toán ngay
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

ServicePayment.propTypes = {
  className: PropTypes.string,
};

export default ServicePayment;